import { css } from "@emotion/react";
import settings from "@settings";

export const scrollButtonContainer = settings.mq({
    position: 'fixed',
    zIndex: 8,
    boxShadow: settings.shadows.regular,
})

export const scrollButton = css({
    backgroundColor: settings.colors.light,
    padding: settings.padding.medium,
    fontFamily: 'Coco Sharp',
    fontWeight: 700,
    fontSize: settings.fontSize.small,
    textTransform: 'uppercase',
    letterSpacing: '2px',
    display: 'flex',
    alignItems: 'center',
    gap: settings.sizes.small,
    cursor: 'pointer'
})